import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-brand-copper text-white pt-20 pb-10" data-id="element-178">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-179">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-180">
          {/* Brand Col */}
          <div className="lg:col-span-1" data-id="element-181">
            <div className="flex flex-col items-start mb-6" data-id="element-182">
              <img src="https://cdn.magicpatterns.com/uploads/fx5ikhxZRrcCdL4VuBBQQb/singderm-logo-w_(1).png" alt="Singderm" className="h-12 w-auto object-contain" data-id="element-183" />
            </div>
            <p className="text-white/90 text-sm leading-relaxed mb-6" data-id="element-184">
              {t('footer.description')}
            </p>

            {/* Social Media Links */}
            <div className="flex space-x-3" data-id="element-185">
              <a href="https://www.facebook.com/singdermthailand" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#1877F2] transition-colors" title="Facebook" data-id="element-186">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-187">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-188" />
                </svg>
              </a>
              <a href="https://www.instagram.com/singdermthailand" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#E4405F] transition-colors" title="Instagram" data-id="element-189">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-190">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" data-id="element-191" />
                </svg>
              </a>
              <a href="https://www.tiktok.com/@singderm_thailand" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-black transition-colors" title="TikTok" data-id="element-192">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-193">
                  <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" data-id="element-194" />
                </svg>
              </a>
              <a href="https://line.me/R/ti/p/@singdermthailand" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#06C755] transition-colors" title="LINE" data-id="element-195">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-196">
                  <path d="M19.365 9.863c.349 0 .63.285.63.631 0 .345-.281.63-.63.63H17.61v1.125h1.755c.349 0 .63.283.63.63 0 .344-.281.629-.63.629h-2.386c-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63h2.386c.346 0 .627.285.627.63 0 .349-.281.63-.63.63H17.61v1.125h1.755zm-3.855 3.016c0 .27-.174.51-.432.596-.064.021-.133.031-.199.031-.211 0-.391-.09-.51-.25l-2.443-3.317v2.94c0 .344-.279.629-.631.629-.346 0-.626-.285-.626-.629V8.108c0-.27.173-.51.43-.595.06-.023.136-.033.194-.033.195 0 .375.104.495.254l2.462 3.33V8.108c0-.345.282-.63.63-.63.345 0 .63.285.63.63v4.771zm-5.741 0c0 .344-.282.629-.631.629-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63.346 0 .628.285.628.63v4.771zm-2.466.629H4.917c-.345 0-.63-.285-.63-.629V8.108c0-.345.285-.63.63-.63.348 0 .63.285.63.63v4.141h1.756c.348 0 .629.283.629.63 0 .344-.282.629-.629.629M24 10.314C24 4.943 18.615.572 12 .572S0 4.943 0 10.314c0 4.811 4.27 8.842 10.035 9.608.391.082.923.258 1.058.59.12.301.079.766.038 1.08l-.164 1.02c-.045.301-.24 1.186 1.049.645 1.291-.539 6.916-4.078 9.436-6.975C23.176 14.393 24 12.458 24 10.314" data-id="element-197" />
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-198">
            <h4 className="text-lg font-semibold mb-6" data-id="element-199">
              {t('footer.quickLinks')}
            </h4>
            <ul className="space-y-3 text-sm text-white/90" data-id="element-200">
              <li data-id="element-201">
                <Link to="/products" className="hover:text-brand-darkCopper transition-colors" data-id="element-202">
                  {t('nav.products')}
                </Link>
              </li>
              <li data-id="element-203">
                <Link to="/before-after" className="hover:text-brand-darkCopper transition-colors" data-id="element-204">
                  {t('nav.beforeAfter')}
                </Link>
              </li>
              <li data-id="element-205">
                <Link to="/treatment-areas" className="hover:text-brand-darkCopper transition-colors" data-id="element-206">
                  {t('nav.treatmentAreas')}
                </Link>
              </li>
              <li data-id="element-207">
                <Link to="/about" className="hover:text-brand-darkCopper transition-colors" data-id="element-208">
                  {t('nav.aboutUs')}
                </Link>
              </li>
              <li data-id="element-209">
                <Link to="/blog" className="hover:text-brand-darkCopper transition-colors" data-id="element-210">
                  {t('nav.blog')}
                </Link>
              </li>
              <li data-id="element-211">
                <Link to="/contact" className="hover:text-brand-darkCopper transition-colors" data-id="element-212">
                  {t('nav.contactUs')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="lg:col-span-2" data-id="element-213">
            <h4 className="text-lg font-semibold mb-6" data-id="element-214">
              {t('footer.contactUs')}
            </h4>
            <ul className="space-y-4 text-sm text-white/90" data-id="element-215">
              <li className="flex items-start" data-id="element-216">
                <MapPin size={18} className="mr-3 mt-0.5 flex-shrink-0 text-white" data-id="element-217" />
                <span data-id="element-218">
                  บริษัท โพล่า กรุ๊ป จำกัด (สำนักงานใหญ่)
                  <br data-id="element-219" />
                  171/1 อาคารปิติการณ์เพลส ชั้นที่ 1
                  <br data-id="element-220" />
                  ห้องเลขที่ 106, 107, 109, 110
                  <br data-id="element-221" />
                  ซอย จรัญสนิทวงศ์ 12 ถนนจรัญสนิทวงศ์
                  <br data-id="element-222" />
                  แขวงวัดท่าพระ เขตบางกอกใหญ่ กรุงเทพมหานคร 10600
                </span>
              </li>
              <li className="flex items-center" data-id="element-223">
                <Phone size={18} className="mr-3 flex-shrink-0 text-white" data-id="element-224" />
                <span data-id="element-225">065-242-5494</span>
              </li>
              <li className="flex items-center" data-id="element-226">
                <Mail size={18} className="mr-3 flex-shrink-0 text-white" data-id="element-227" />
                <span data-id="element-228">polamkt01@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-white/70" data-id="element-229">
          <p data-id="element-230">{t('footer.copyright')}</p>
          <div className="flex space-x-4 mt-4 md:mt-0" data-id="element-231">
            <a href="#" className="hover:text-white transition-colors" data-id="element-232">
              {t('footer.privacy')}
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-233">
              {t('footer.terms')}
            </a>
          </div>
        </div>
      </div>
    </footer>;
}